import { render } from "./DataviewComponent.vue?vue&type=template&id=faf7bb6a"
import script from "./DataviewComponent.vue?vue&type=script&lang=js"
export * from "./DataviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__